<p-tabView>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span class="tab-header">
                <i class="fa fa-user-cog mr-3"></i>Allgemein
                <i *ngIf="isGeneralTabInvalid" class="fa fa-exclamation-triangle ml-2" style="color: red; font-size: 12px;"></i>
            </span>
        </ng-template>
        <div class="dialog-container">
            <div class="grid p-fluid p-input-filled dialog-row">
                <div class="col-6">
                    <span class="p-float-label">
                        <input type="text" [(ngModel)]="user.userName" pInputText [ngClass]="{'ng-invalid ng-dirty': isUserNameInvalid}">
                        <label>Benutzername *</label>
                    </span>
                    <small *ngIf="isUserNameInvalid" class="p-error">Benutzername ist erforderlich (mindestens 2 Zeichen)</small>
                </div>
                <div class="col-6">
                    <span class="p-float-label">
                        <input type="text" [(ngModel)]="user.userNumber" pInputText [ngClass]="{'ng-invalid ng-dirty': isUserNumberInvalid}">
                        <label>Benutzernummer *</label>
                    </span>
                    <small *ngIf="isUserNumberInvalid" class="p-error">{{userNumberValidationMessage}}</small>
                </div>
            </div>
            <div class="grid p-fluid p-input-filled dialog-row">
                <div class="col-6">
                    <span class="p-float-label">
                        <input type="text" [(ngModel)]="user.firstName" pInputText>
                        <label>Vorname</label>
                    </span>
                </div>
                <div class="col-6">
                    <span class="p-float-label">
                        <input type="text" [(ngModel)]="user.lastName" pInputText [ngClass]="{'ng-invalid ng-dirty': isLastNameInvalid}">
                        <label>Nachname *</label>
                    </span>
                    <small *ngIf="isLastNameInvalid" class="p-error">Nachname ist erforderlich (mindestens 2 Zeichen)</small>
                </div>
            </div>
        </div>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span class="tab-header">
                <i class="fa fa-user-tag mr-3"></i>Rechte
                <i *ngIf="isRightsTabInvalid" class="fa fa-exclamation-triangle ml-2" style="color: red; font-size: 12px;"></i>
            </span>
        </ng-template>
        <div class="dialog-container">
            <div class="grid p-fluid p-input-filled dialog-row">
                <div class="col-3">
                    <div class="field-checkbox">
                        <p-checkbox [(ngModel)]="isDispatcher" [binary]="true" [disabled]="(currentUser.isAdmin === false)"></p-checkbox>
                        <label style="font-size: 18px;">Disponent</label>
                    </div>
                </div>
                <div class="col-3">
                    <div class="field-checkbox">
                        <p-checkbox [(ngModel)]="isAdmin" [binary]="true" [disabled]="(currentUser.isAdmin === false)"></p-checkbox>
                        <label style="font-size: 18px;">Administrator</label>
                    </div>
                </div>
                <div class="col-3">
                    <div class="field-checkbox">
                        <p-checkbox [(ngModel)]="isAdminSuper" [binary]="true" [disabled]="(currentUser.isAdminSuper === false)"></p-checkbox>
                        <label style="font-size: 18px;">Super-Admin</label>
                    </div>
                </div>
                <div class="col-3">
                    <div class="field-checkbox">
                        <p-checkbox [(ngModel)]="isMobileUser" [binary]="true" [disabled]="(currentUser.isAdmin === false)"></p-checkbox>
                        <label style="font-size: 18px;">Mobile</label>
                    </div>
                </div>
            </div>
            <div *ngIf="isRoleInvalid" class="grid p-fluid p-input-filled dialog-row">
                <div class="col-12">
                    <small class="p-error">Der Benutzer muss mindestens eine Rolle (Disponent oder Administrator) haben</small>
                </div>
            </div>
            <div class="grid p-fluid p-input-filled dialog-row">
            </div>
            <div class="grid p-fluid p-input-filled dialog-row">
                <div class="col-6">
                    <div class="field-checkbox">
                        <p-checkbox [(ngModel)]="isActive" [binary]="true" [disabled]="(currentUser.isAdmin === false)"></p-checkbox>
                        <label style="font-size: 18px;">Aktiv</label>
                    </div>
                </div>
            </div>
            <div *ngIf="((user?.mandator?.useLDAP !== true))" class="grid p-fluid p-input-filled dialog-row">
                <div *ngIf="(user.id !== null)" class="col-6">
                    <div class="field-checkbox">
                        <p-checkbox [(ngModel)]="user.passwordResetRequested" [binary]="true" [disabled]="(currentUser.isAdmin === false)"></p-checkbox>
                        <label style="font-size: 18px;">Kennwort zurücksetzen</label>
                    </div>
                </div>
                <div *ngIf="((user.id === null) || (user.passwordResetRequested === true))" class="col-6">
                    <span class="p-float-label">
                        <input type="password" [(ngModel)]="user.password" pInputText [ngClass]="{'ng-invalid ng-dirty': isPasswordInvalid}">
                        <label>Initial-Password *</label>
                    </span>
                    <small *ngIf="isPasswordInvalid" class="p-error">Initial-Password ist erforderlich</small>
                </div>
            </div>
        </div>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <span class="tab-header"><i class="fa fa-warehouse mr-3"></i>Depots</span>
        </ng-template>
        <div class="dialog-container">
            <ng-container *ngFor="let depot of (depots$ | async)">
                <div class="grid p-fluid p-input-filled">
                    <div class="col-12">
                        <div class="field-checkbox">
                            <p-checkbox [binary]="true" [ngModel]="getUserHasDepot(depot)" [disabled]="(currentUser.isAdmin === false)" (onChange)="onDepotCheckChanged($event, depot)"></p-checkbox>
                            <label style="font-size: 18px;">{{depot.completeDescription}}</label>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </p-tabPanel>
</p-tabView>
<div style="text-align: right;">
    <p-button icon="fa fa-times" label="Abbrechen" styleClass="p-button-text p-button-danger p-button-lg" (onClick)="cancelAsync()"></p-button>
    <p-button icon="fa fa-check" label="Speichern" styleClass="p-button-text p-button-success p-button-lg" [disabled]="(canSave === false)" (onClick)="saveAsync()"></p-button>
</div>
